import RestClient from '@agoras/rest-client';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppContext } from '../components/context/context.esm.js';
import logger from '@agoras/logger';
import { useLocale } from './useLocale.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function useUserQuery() {
    var user = useContext(AppContext).user;
    var locale = useLocale().locale;
    var signedIn = user.signedIn, favoritesCount = user.favoritesCount;
    var userQuery = useQuery({
        queryKey: [
            'leads-me-user'
        ],
        queryFn: function() {
            return RestClient.Leads.me();
        },
        onSuccess: function(data) {
            var tid = data.tid;
            logger.setContext({
                user: {
                    tid: tid,
                    signedIn: signedIn
                },
                locale: locale.language || ''
            });
        },
        enabled: signedIn,
        staleTime: Infinity
    });
    return _object_spread_props(_object_spread({}, userQuery.data), {
        favoritesCount: favoritesCount
    });
}

export { useUserQuery };
